import { createContext, useContext } from 'react';

interface ExperienceAnnotationEntry {
  dimension: string;
  key: string;
  label: string;
  totalMinutes: number;
  matterCount: number;
  maxMinutes: number;
  profilePicture?: string;
  starred?: boolean;
}

interface ExperienceSearchContextValue {
  experienceScope?: string;
  experienceAnnotations?: { [userId: string]: ExperienceAnnotationEntry[] };
}

const ExperienceSearchContext = createContext<ExperienceSearchContextValue>({});

export const ExperienceSearchProvider = ExperienceSearchContext.Provider;

export const useExperienceSearchContext = () => useContext(ExperienceSearchContext);
